// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__20tm0","content":"Consent_content__aeBmQ","footer":"Consent_footer__5jq1O"};